
import { RegistrationFormValues } from './types';

export const transformToRequestRegister = (
  formValues: RegistrationFormValues
): any => {
  return {
    tenantType: formValues.tenantType,
    firstName: formValues.firstName ?? "",
    lastName: formValues.lastName ?? "",
    companyName: formValues.companyName ?? "",
    taxNumber: formValues.taxNumber ?? "",
    email: formValues.email,
    password: formValues.password,
  };
};
